<template>
	<v-row
		justify = "center"
		align 	= "center"
	>
		<v-col
			xl 	 = "8"
			lg 	 = "10"
			md 	 = "10"
			sm 	 = "10"
			xs   = "12"
			cols = "12"
		>
			<v-card outlined>
				<v-card-title
					class = "body-2 secondary pa-1 white--text"
				>	
					<v-icon 
						small 
						color  = "white"
						class  = "ml-1"
						@click = "$router.back()"
					>
						mdi-arrow-left-circle
					</v-icon>
					<v-spacer></v-spacer>
					<v-icon
						x-small
						v-text = "'mdi-alarm'"
						class  = "mx-2"
						color  = "white"
					></v-icon>
					<span 
						v-text = "$ml.get('smart_event')"
					></span>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-card-text
					class = "pa-1"
				>
					<v-row
						dense
					>
						<v-col 
							xl 	 = "2"
							lg 	 = "2"
							md 	 = "2"
							sm 	 = "3"
							xs 	 = "3"
							cols = "3"
							v-show = "show.add_smart"
							
						>
							<v-card >
								<v-card-title
									class = "pa-1 pl-1 secondary body-2 white--text"
								>
									<v-icon
										x-small
										color = "white"
										class = "mx-1"
									>
										mdi-form-select
									</v-icon>
									{{ $ml.get('options') }}
								</v-card-title>
								<v-card-text class = "pa-1 pt-0">
										
									<v-list dense>
										<v-list-item-group
										 	
										>
											<template
												v-for = "(btn_option, btn_index) of option_alarms"
												v-if  = "btn_option.enable"
											>	
												<v-card 
													outlined 
													:color = "btn_option.color"
													class  = "mt-1"
												>
												<v-list-item 
													:key   = "btn_index"	
													@click = "redirect(btn_option.btn_action, btn_option.key)"

												>
													<v-list-item-icon
													 		class = "mx-0"
													 	>
											            	<v-icon 
											            		small
											            		color  = "white"
											            		v-text = "btn_option.icon"
											          	></v-icon>
											        </v-list-item-icon>
													<v-list-item-title
														class  = "white--text"
														v-text = "btn_option.title"
													></v-list-item-title>
												</v-list-item>
											</v-card>
											</template>
										</v-list-item-group>
									</v-list>
								</v-card-text>
							</v-card>
						</v-col>
						<v-col>
							<v-toolbar
						    		
						    		dense
						    		height = "25"
						    		class  = "secondary white--text"
						    	>
						    	<v-toolbar-title 
						    		class = "body-2"
						    	>	
						    		<v-icon
										small
										color = "white"
										class = "ml-1"
									>
										mdi-view-list
									</v-icon>
									<span>										
						    			{{ $ml.get('registered_smart_event') }}
									</span>
						    		<!-- Registered Alarms -->
						    	</v-toolbar-title>
						    </v-toolbar>
								
							<v-divider></v-divider>
							<v-data-table
								dense
							    fixed-body
							    fixed-header
								:headers 			 = "header_table"
								:items 				 = "render_list"
								class 				 = "elevation-5"
								:options.sync 		 = "options"
							   	:server-items-length = "total"
							   	loading-text 		 = "Loading... Please wait"
							   	:loading 			 = "loading"
							    item-key 			 = "index"
							    :height 			 = "layout_height + 'px'"
							   	:footer-props 		 = "{
							   		showFirstLastPage 	: true,
							   		itemsPerPageOptions : [15, 30],
							   		showCurrentPage 	: true,
							   		itemsPerPageText 	: ''
							   	}"
							>
							    <!-- rowsPerPageText: [30] -->
								<template v-slot:item.options = "{ item }" >
									<v-btn
										x-small
										color  = "primary"
										@click = "redirect('settings_alarm', item)"
										v-show = "show.edit_smart"
									>
										<v-icon
											x-small
											v-text = "'mdi-pencil'"
										></v-icon>
									</v-btn>	
									<v-btn
										x-small
										color  = "error"
										class  = "mx-1"
										@click = "actions('confirm_delete', item)"
										v-show = "show.delete_smart"
									>
										<v-icon
											x-small
											v-text  = "'mdi-delete'"
										></v-icon>
									</v-btn>							
								</template>
								<template v-slot:item.actions = "{ item }" >
									<v-btn
										x-small
										v-for  = "(item_btn, idx_btn) of item.actions"
										:key   = "idx_btn"
										:color = "item_btn.active ? 'primary' : 'secondary'"
										@click = "save_action(item_btn)"
										v-show = "show.edit_smart"
									>
										<v-icon
											x-small
										>
											{{ item_btn.icon }}
										</v-icon>
									</v-btn>
								</template>
								<template v-slot:item.analytic = "{ item }" >
									<div
										v-if = "item.analytic && item.analytic.length > 0"
										class = "py-1"
									>
										<div
											v-for = "(item_analytic, idx_analytic) of item.analytic"
											:key  = "idx_analytic"
											class = "caption"
										>
											<strong>{{ item_analytic.title }}</strong>
											<span v-if = "item_analytic.detail">
												- {{ item_analytic.detail }}
											</span>
										</div>
									</div>
									<span
										v-else
										class = "caption grey--text"
									>
										-
									</span>
								</template>
							</v-data-table>

						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
	import EventBus from '@/event-bus'
	import { getTerminalFaceListDisplayName, TERMINAL_FACE_LIST_LABEL_KEY } from '@/components/alarms/alarm_rules.vue'

	export default {
		name: 'add_alarms',
		data: (vm) => ({
			info 		 : {},
			header_table : [
				{ text: vm.$ml.get('name'), value: 'name' },
				{ text: vm.$ml.get('count_device'), value: 'count_device' },
				{ text: vm.$ml.get('analytic'), value: 'analytic' },
				// { text: vm.$ml.get('actions'), value: 'actions' },
				// { text: vm.$ml.get('options'), value: 'options' },
				,
				// { text: vm.$ml.get('constellation'), value: 'constellation' },
			],
			options 		: { itemsPerPage: 30},
			total 			: 0,
			layout_height 	: 500,
			option_alarms 	: [
				{ 
					title: 'New alarm', 
					key: 'new',
					color: 'primary', 
					enable: true, 
					btn_action: 'settings_alarm', 
					icon 		: 'mdi-alarm-plus',
				},
				{ 
					title: 'Categories', 
					key: 'categiries',
					color: 'secondary', 
					enable: false, 
					btn_action: 'categories', 
				},
				{ 
					title: 'Access rules', 
					key: 'access_rules',
					color: 'secondary', 
					enable: false, 
					btn_action: 'access_rules', 
				},
			],
			list 	: [],
			list_multi : [],
			loading : false,
			bus 	: {},
			show 	: {
				add_smart  		: false,
				edit_smart 		: true,
				delete_smart 	: true,
			},
			permission 	  : {
				"roles": [1, 2]
			},
		}), // data

		created(){
			this.get_listing();
			// this.get_list();
			let modul = this.$store.getters["auth/permission"](this.$route.name || "smart_event", "", "smart_event");
			if (modul){ // this.$Helper.current_auth_user(this.currentUser, this.permission)
				if (modul.can_add) {					
					this.show.add_smart  = true; 
				}
				if (!modul.can_edit) {
					this.show.edit_smart = false;
				}
				if (!modul.can_delete) {
					this.show.delete_smart = false;
				}
				if (modul.can_edit || modul.can_delete) {					
					if (modul.can_edit) {
						this.header_table.push({ text: this.$ml.get('actions'), value: 'actions'});
					}
					this.header_table.push({ text: this.$ml.get('options'), value: 'options' });
				}
				// if (this.$router.currentRoute.name == 'device') {
				// }
			}
		}, // created

		watch:{
			options: {
				handler(){
					this.get_list();
				}, deep: true,
			}, // options

		}, // watch

		computed:{
			render_list: function(){
				return this.list;
			}, // render list
			currentUser(){
      			return this.$store.state.auth.user;      			
      		}, // currentUser
		}, // computed

		methods: {
			actions(act, item){
				if ( act == 'confirm_delete' ) {
					this.info = item;
					EventBus.$emit('notifications_modal', {
						type : 'confirm_delete',
						ID   :  'alarms',  
					})
				}
				if ( act == 'delete' ) {
					this.delete();
				}

			}, // actions

			get_list(){
				const { itemsPerPage, page } = this.options;
				let pg = 1, sw = 0;
				let vm = this;
				this.loading = true;

				if ( itemsPerPage == 15 ) {
					if (page % 2 == 0) {
						pg = (page/2);
						sw = 2;
					}else{
						pg = parseInt(page/2)+1;
						sw = 1;
					}
				}else{
					pg = page
				}
				const api = this.$URL + '/api/v1/alarm/?page='+pg;
				
				this.$axios.get(api).then( res => {
					console.log(res, 'Get list');
					let items  = res.data.rows;
					this.total = parseInt(res.data.count);
					if (items && items.length > 0) {		

						// this.$SmartEvent.set("list_smart_event", [ ...items], "delete_list", parseInt(res.data.page));

						if (itemsPerPage <= 15) {
							items = items.slice((sw - 1) * itemsPerPage, sw  + itemsPerPage );
						}
						items = this.render_list_smart(items);
						this.list = items;
						// this.save_local(items);
					}
					this.loading = false;

				}).catch( er => {
					console.log(er, 'Error get list');
					this.loading = false;
					/*if (er && er.message == 'Network Error') {
						EventBus.$emit('notifications_modal', {
							type : 'error',
							message : er.message 

						})
					}*/
					this.get_local();
				})
			}, // get list

			get_local(){
				let list_temp = [];
				if (localStorage.getItem('alarms')) {
					list_temp = JSON.parse(localStorage.getItem('alarms'));
					this.list = this.render_list_smart(list_temp);
				}else{
					console.log('Error get alarms');
				}
				// console.log(list_temp);
			}, // get local

			save_local(opt = false, item){
				let list_temp = [];
				if (localStorage.getItem('alarms')) {
					list_temp = JSON.parse(localStorage.getItem('alarms'));
				}
				if (opt) {
					let search = item;//this.info.id;
					list_temp.splice(list_temp.indexOf(search), 1);
				}
				localStorage.setItem('alarms', JSON.stringify(list_temp));				
			}, // save local

			delete(){
				let info_del = this.info;

				if (info_del && info_del.id) {
					const api = this.$URL + '/api/v1/alarm/' + info_del.id;

					this.$axios.delete( api ).then( res => {
						console.log(res, 'Delete res alarms');
						this.list.splice(this.list.indexOf(info_del), 1);
						this.total --;
						this.save_local(true, info_del);
						EventBus.$emit('notifications_modal', {
							type : 'deleted'
						});
					}).catch( er => {
						console.log(er, 'Error delete alarms');
					})
				}
			}, // delete

			redirect(url, item){
				if (url == 'settings_alarm') {
					console.log("clear alarms local ***************************************")
					localStorage.removeItem("settings_alarm");
					localStorage.removeItem("rule_alarm");
					localStorage.removeItem("device_alarm");
					localStorage.removeItem("action_alarm");
					localStorage.setItem("settings_alarm", JSON.stringify(item));
				}
				const  timer = setTimeout( () => {
					this.$router.push(url);
					clearTimeout(timer);
				}, 50)
			}, // redirect

			save_action(item){
				if (item && item.id) {
					let info_up = item.value;
					if (item.key) {
						info_up[item.key] = !item.active;
						item.active 	  = info_up[item.key]; 

					}
					const api = this.$URL + '/api/v1/alarm/action/' + item.id;
					this.$axios.put(api, info_up).then( res => {
						this.$EventBus.$emit("notifications_modal",{
							type 	: 'updated',
							message : this.$ml.get('actions')
						})
					}).catch( er => {
						console.log("Error update action ", er);
						this.$EventBus.$emit("notifications_modal",{
							type 	: 'error',
							message : er
						});
						if (item.key) {
							info_up[item.key] = !item.active;
							item.active 	  = info_up[item.key]; 

						}
					})
				}else{
					console.log("No found info  or property ID for update action");
					this.$EventBus.$emit("notifications_modal",{
						type 	: 'warning',
						message : this.$ml.get('not_found_propierties')
					});
				}
			}, // save action

				get_listing(pg = 1){
					const api = this.$URL + '/api/v1/list/?page=' + pg;

					this.$axios.get(api).then( res => {
						if (res && res.data && res.data.rows && res.data.rows.length > 0) {
							this.list_multi = this.list_multi.concat(res.data.rows);

							if (parseInt(res.data.pages) > pg) {
								this.get_listing(pg + 1);
								return;
							}

							if (this.list && this.list.length > 0) {
								this.list = this.render_list_smart(this.list);
							}
						}
					}).catch( er => {
						console.log(er, 'Error get_list');
					})
				},

				format_detail_value(value){
					if (Array.isArray(value)) {
						return value.filter(x => x !== null && x !== undefined && x !== '').join(', ');
					}
					return value;
				},

				render_list_name(idList){
					let list = this.list_multi || [],
						item = list.find( x => x && String(x.id) === String(idList));

					return item && item.name ? item.name : this.$ml.get('n_a');
				},

				push_detail(parts, label, value, suffix = ''){
					if (value === null || value === undefined || value === '') return;
					parts.push(this.$ml.get(label) + ': ' + this.format_detail_value(value) + suffix);
				},

				render_rule_detail(rule, analytic, alarm){
					let detail = [],
						title  = this.$ml.get(analytic || 'analytic');

					this.push_detail(detail, 'tag', rule.tag);
					this.push_detail(detail, 'minimum_time', rule.alertime);
					this.push_detail(detail, 'probability', rule.prob, rule.prob !== null && rule.prob !== undefined && rule.prob !== '' ? '%' : '');
					this.push_detail(detail, 'capacity', rule.countag);
					this.push_detail(detail, 'side', rule.side);
					this.push_detail(detail, 'way', rule.way);
					this.push_detail(detail, 'direction', rule.direction);
					const terminalFaceListLabel = analytic === 'face'
						? getTerminalFaceListDisplayName(
							rule,
							{ devices: alarm && alarm.Detail_device_alarm ? alarm.Detail_device_alarm : [] },
							this.list_multi,
							this.$ml.get(TERMINAL_FACE_LIST_LABEL_KEY)
						)
						: null;
					if (terminalFaceListLabel) {
						this.push_detail(detail, 'list', terminalFaceListLabel);
					}else if (rule.idList !== null && rule.idList !== undefined && rule.idList !== '') {
						this.push_detail(detail, 'list', this.render_list_name(rule.idList));
					}
					this.push_detail(detail, 'entity', rule.entity);
					this.push_detail(detail, 'access', rule.access);
					this.push_detail(detail, 'speed', rule.speed);
					this.push_detail(detail, 'technical_status', rule.status);

					return {
						title,
						detail   : detail.join(', '),
						analytic : analytic,
						type     : 'rule',
					};
				},

				render_action_detail(action){
					let detail = [],
						fields = [
							{ key : 'ismodal', text : 'popup' },
							{ key : 'isnotificable', text : 'notifiable' },
							{ key : 'issendtows', text : 'send_ws' },
							{ key : 'issendemail', text : 'send_email' },
							{ key : 'issound', text : 'sound' },
							{ key : 'isalert', text : 'alert' },
							{ key : 'manual_confirmation', text : 'require_confirmation' },
						];

					fields.forEach(field => {
						if (action[field.key]) {
							detail.push(this.$ml.get(field.text));
						}
					});
					this.push_detail(detail, 'alert_time', action.timeout, action.timeout !== null && action.timeout !== undefined && action.timeout !== '' ? 's' : '');

					return {
						title    : this.$ml.get('actions'),
						detail   : detail.length > 0 ? detail.join(', ') : this.$ml.get('off'),
						analytic : 'actions',
						type     : 'actions',
					};
				},

				render_list_smart(items){
				if (items && items.length > 0) {
					let vm = this;
					items.forEach( (dev, idx_dev) => {
						if (dev.Detail_action_alarm && dev.Detail_action_alarm.length > 0) {
							dev.actions = 
								[{ 
									id 		: dev.Detail_action_alarm[0].id,
									key 	: "issound",
									value 	: dev.Detail_action_alarm[0],
									icon  	: "mdi-volume-high",
									active 	: dev.Detail_action_alarm[0].issound, 
								},
								{
									id 		: dev.Detail_action_alarm[0].id,								
									key 	: "ismodal", // popup
									value 	: dev.Detail_action_alarm[0],									
									icon 	: "mdi-message-alert",
									active 	: dev.Detail_action_alarm[0].ismodal, // popup
								}]
						}else {
							dev.actions = [
								{ 
									key 	: "issound",
									icon  	: "mdi-volume-high",
									active 	: false, 
								},
								{
									key 	: "ismodal", // popup
									icon 	: "mdi-message-alert",
									active 	: false,
								}
							]
						}
						if (dev.Detail_device_alarm && dev.Detail_device_alarm.length > 0) {
							console.log("DEVICES : ", dev.Detail_device_alarm);
							dev.count_device = 0;
							dev.Detail_device_alarm.forEach( (dev_count) =>{
								if (dev_count.state) {
									dev.count_device ++;
								}
							})
						}else{
							dev.count_device = 0;
						}
						dev.analytic  = [];	
						if (dev.Detail_rule_obj_alarm && dev.Detail_rule_obj_alarm.length > 0) {

							dev.Detail_rule_obj_alarm.forEach( (obj) =>{
								dev.analytic.push(vm.render_rule_detail(obj, 'object'));
							})

						}
						if (dev.Detail_motion_alarm && dev.Detail_motion_alarm.length > 0) {
							dev.Detail_motion_alarm.forEach( motion => {
								dev.analytic.push(vm.render_rule_detail(motion, 'motion'));
							})
						}
						if (dev.Detail_rule_face__alarm && dev.Detail_rule_face__alarm.length > 0) {
							dev.Detail_rule_face__alarm.forEach( face => {
								dev.analytic.push(vm.render_rule_detail(face, 'face', dev));
							})
						}
						if (dev.Detail_rule_lpr__alarm && dev.Detail_rule_lpr__alarm.length > 0) {
							let tempLpr = dev.Detail_rule_lpr__alarm.filter(x=> x && x.type =='lpr');
							tempLpr.forEach( lpr => {
								dev.analytic.push(vm.render_rule_detail(lpr, 'lpr'));
							})
							let tempParking = dev.Detail_rule_lpr__alarm.filter(x=> x && x.type =='parking');
							tempParking.forEach( parking => {
								dev.analytic.push(vm.render_rule_detail(parking, 'parking'));
							})

						}
						if (dev.Detail_rule_action_alarm && dev.Detail_rule_action_alarm.length > 0) {
							dev.Detail_rule_action_alarm.forEach( actionRule => {
								dev.analytic.push(vm.render_rule_detail(actionRule, 'actions'));
							})
						}
						if (dev.Detail_action_alarm && dev.Detail_action_alarm.length > 0) {
							dev.analytic.push(vm.render_action_detail(dev.Detail_action_alarm[0]));
						}
					});

					if (this.total === 0) {
						this.total = items.length === 1 ? 1 : items.length;
					}
					return items;

				}
				return [];
			}, // render list smart

		}, // methods


		mounted(){
			let temp_bus = 'notifications_modal' + 'alarms';
			EventBus.$on(temp_bus, this.bus[temp_bus] = (action) =>{
				if (action) {
					this.actions('delete');
				}
			})
		}, // mounted	

		beforeDestroy(){
			this.list = [];
			this.$Helper.clear_bus(EventBus, this.bus, 'add alarms(smart_event)');
		}, // before destroy
	};
</script>
